import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';
import ManageProducts from 'src/components/Elements/ManageProducts';

const ProductManagementModal = () => (
  <ModalBase
    name={MODALS.manageProducts}
    size={MODALS_SIZE.small}
    form={FORM.get_products}>
    <ManageProducts />
  </ModalBase>
);

export default ProductManagementModal;
